import React from 'react';
import { 
    Responsive, // eslint-disable-line
    List, SimpleList, Datagrid, // eslint-disable-line
    Edit, Create, Filter, // eslint-disable-line
    EditButton, SimpleForm, TabbedForm, FormTab, // eslint-disable-line
    NumberInput, TextInput, LongTextInput, BooleanInput, SelectInput, SelectArrayInput, ReferenceInput, ReferenceArrayInput, DisabledInput, ImageInput, // eslint-disable-line
    NumberField, TextField, DateField, BooleanField, ReferenceField, ReferenceArrayField, SingleFieldList, ChipField, ImageField, EmailField, PasswordField // eslint-disable-line
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
// import IconField from '../fields/IconField';
// import {TYPE_ICONS} from '../constants/icons';

const TypesFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn />
        <BooleanInput label="Online" source="online" />
        <ReferenceInput label="Creator" source="createdBy" reference="users">
            <SelectInput optionText="name" />
        </ReferenceInput>
    </Filter>
);

export const TypesList = (props) => (
    <List {...props} filters={<TypesFilter />} bulkActions={false}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.slug}
                />
            }
            medium={
                <Datagrid>
                    <BooleanField source="online" />
                    <TextField source="name" />
                    <NumberField source="nav" />
                    <EditButton />
                </Datagrid>
            }
        />
    </List>
);

const TypesTitle = ({ record }) => {
    return <span>Type {record ? `"${record.name}"` : ''}</span>;
};

export const TypesEdit = (props) => (
    <Edit name={<TypesTitle />} {...props}>
        <TabbedForm>
            <FormTab label="Info">
                <TextInput source="name" />
                <TextInput source="desc" />
            </FormTab>
            <FormTab label="Content">
                <RichTextInput source="content" />
            </FormTab>
            <FormTab label="Settings">
                <BooleanInput source="online" />
                <NumberInput source="nav" />
            </FormTab>
            <FormTab label="Meta">

                <ReferenceField source="createdBy" reference="users" allowEmpty={true}>
                    <TextField source="name" />
                </ReferenceField>
                <DateField source="createdAt" showTime />

                <ReferenceField source="updatedBy" reference="users" allowEmpty={true}>
                    <TextField source="name" />
                </ReferenceField>
                <DateField source="updatedAt" showTime />

            </FormTab>
        </TabbedForm>
    </Edit>
);

export const TypesCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
        </SimpleForm>
    </Create>
);